import { useRouteLoaderData } from 'react-router';

export function useSearchJobsRouteLoaderData() {
  const loaderData = useRouteLoaderData(`search-jobs-${CURRENT_LOCALE()}`)!;

  const { synonym, facetCounts } = loaderData ?? {};

  const {
    familyId,
    jobSynonym: { name },
  } = synonym ?? {
    familyId: null,
    jobSynonym: { name: null },
  };

  return { jobSynonymName: name, jobFamilyId: familyId, facetCounts };
}
